import { render, staticRenderFns } from "./TypeDocumentUniqueAdmin.vue?vue&type=template&id=8ca74d90&"
import script from "./TypeDocumentUniqueAdmin.vue?vue&type=script&lang=js&"
export * from "./TypeDocumentUniqueAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TypeDocumentUniqueAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports